import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { get } from 'lodash'

import { useVerifyDisableMfaMutation } from '@client-hub/store/api/crs/react'
import { MFA_METHOD } from '@client-hub/shared/constants'
import MfaAuth, { MfaAuthContentType } from 'components/Mfa/Auth'
import { AuthCodeSchema } from 'schemas/mfa'
import { handleAuthCodeChange } from 'utils/mfa'
import { useMfaNavigateState, useRedirect } from 'hooks'
import ROUTES from '@client-hub/shared/constants/routes'

import { useTranslation } from 'react-i18next'
import { useNotifications } from '@client-hub/shared/react/hooks/notifications'

const MfaDisable = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const notify = useNotifications()
  const { sms_status, two_factor_auth, isAllowedMfa } = useMfaNavigateState()
  const smsMessage = sms_status?.['message'] || ''
  const [verifyDisableMfa, { isSuccess, error: disableMfaError }] = useVerifyDisableMfaMutation()

  useRedirect(!isAllowedMfa)

  const content: MfaAuthContentType = {
    back: { name: t('routes.mfaAuth.global.back') },
    placeholder: t('forms.mfaAuth.fields.authCode.placeholder'),
    label: two_factor_auth === MFA_METHOD.AUTHENTICATOR_APP ? t('routes.mfaAuth.auth.labelSetup') : smsMessage,
  }

  useEffect(() => {
    isSuccess && navigate(ROUTES.USERS.MY_PROFILE, { replace: true })
  }, [navigate, isSuccess])

  useEffect(() => {
    if (get(disableMfaError, 'status') === 400) {
      if (get(disableMfaError, 'data.non_field_errors[0]')) {
        notify({ message: get(disableMfaError, 'data.non_field_errors[0]'), variant: 'error' })
      } else if (get(disableMfaError, 'data.totp[0]')) {
        notify({ message: get(disableMfaError, 'data.totp[0]'), variant: 'error' })
      }
    }
  }, [disableMfaError, navigate, notify])

  const onSubmit = useCallback((code: string) => verifyDisableMfa({ totp: code }), [verifyDisableMfa])

  if (!isAllowedMfa) return null

  return <MfaAuth content={content} schema={AuthCodeSchema} onChange={handleAuthCodeChange} onSubmit={onSubmit} />
}

export default MfaDisable
